import { mapStrings } from "../../lib/frTypo";

/**
 * "Les cartes" reel — on-screen copy, FR only for now.
 *
 * Sources (landing, packages/landing/src/i18n/locales/fr.json):
 *   - end line  → steps.title.line1 "On est tous des influenceurs"
 *   - end sub   → hero.subtitle.line2 "Avec Frak, tu es payé pour le faire !"
 *   - "peu importe" followers → faq.a3 (no need to be an influencer)
 *   - "à chaque vente via ton lien" → faq.a2
 * The three everyday characters are archetypes (playful, no figures
 * presented as data). B2C house style: tutoiement, no em dashes.
 */
export const CARDS = mapStrings({
  hook: "Les vrais influenceurs n'ont pas 100k abonnés",
  labels: {
    followers: "Abonnés",
    power: "Super-pouvoir",
    pay: "Rémunération",
  },
  cards: [
    {
      name: "La pote bon plan",
      art: "🛍️",
      followers: "214",
      power: "« Je t'envoie le lien »",
      pay: "0 €",
    },
    {
      name: "L'oncle des avis",
      art: "⭐",
      followers: "12",
      power: "« 5 étoiles, crois-moi »",
      pay: "0 €",
    },
    {
      name: "La coloc skincare",
      art: "🧴",
      followers: "389",
      power: "« Teste, tu vas voir »",
      pay: "0 €",
    },
    {
      name: "Toi",
      art: "🫵",
      followers: "Peu importe",
      power: "Tes proches te font confiance",
      pay: "À chaque vente via ton lien",
    },
  ],
  end: {
    line: "On est tous des influenceurs.",
    sub: "Avec Frak, tu es payé pour le faire !",
  },
});
